<template>
  <footer class="footer">
    <div class="footer__background decoration-concours-separtor" />

    <div class="footer__content">
      <div class="footer__pic decoration-concours" />

      <div class="footer__content-text">
        <h2 class="footer__title">
          {{ $store.state.config.contest.title }}
        </h2>

        <p class="footer__text">
          {{ $store.state.config.contest.description }}
        </p>

        <a
          class="footer__cta"
          :href="ctaLink"
        >
          {{ $store.state.config.contest.button }}
        </a>
      </div>
    </div>

    <div class="footer__copyright">
      {{ $store.state.config.copyright }}
    </div>
  </footer>
</template>

<script>
export default {
  computed: {
    ctaLink() {
      return window.___contest || '#';
    },
  },
};
</script>

<style lang="stylus" scoped>
.footer {
  position: relative;

  color: white;
  background-color: black;
  background: linear-gradient(0deg, black 99%, white); // remove white line glitch
}

.footer__background {
  position: absolute;
  z-index: 0;

  width: 100%;
  height: 145px;

  background-color: white;
  background-size: 100% 101%; // 101% remove white line glitch
  border-top: 50px solid white;
}

.footer__content {
  position: relative;
  z-index: 1;

  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 30px;
  margin: 0 auto;

  max-width: 320px;

  +desktop() {
    flex-direction: row;
    align-items: flex-end;
    max-width: 968px;
  }
}

.footer__pic {
  flex-shrink: 0;
}

.footer__content-text {
  +desktop() {
    text-align: left;
    padding-bottom: 60px;
  }
}

.footer__title {
  @extends $txt-title-1;
  color: $cl-secondary;
  margin-bottom: 10px;
}

.footer__text {
  @extends $txt-footer;
  margin-bottom: 15px;
}

.footer__cta {
  @extends $cta, $cta-negative;
  display: inline-block;
}

.footer__copyright {
  @extends $txt-copyright;
  padding: 10px;
  margin-top: 50px;
}
</style>
